// 一般退藥 component

<template lang="pug">
div
  div.upper-subpanel.row
    progressBar
    div.upper-subpanel--without-progressbar
      scanBarcode(v-if="drugSetMethod === 'barcode' && stage === 'selectDrug'" v-on:setBarcode="getBarcode")
        div.with-child-centered
          h3 請掃描藥單條碼進行
            strong 退藥
      eventTable(v-if="drugSetMethod === 'event' && stage === 'selectDrug'" :eventType="eventType" :singleSelection="true" :noChecked="true")
      eventTable(v-if="drugSetMethod === 'returnSchedule' && stage === 'selectDrug'" :eventType="eventType" :singleSelection="false" :number2="returnScheduleId")
      div.druglist-wrap(v-if="drugSetMethod === 'manual' && stage === 'selectDrug'")
        drugList(:singleSelection="true")
      MultiFlow(v-if="stage === 'setFlowData'" 
        v-on:setAllConfirmData="getAllConfirmData"
        :multiProgress="multiProgress"
        :confirmProgress="confirmProgress"
        :actionProgress="actionProgress"
        :startType="startType"
        :barcodeData="barcodeData")
      Loader(v-if="stage === 'finish'")
  BottomButtons
    action-button(title="回主畫面" slot="button-1" @click.native="cancel")
    action-button(title="病人列表" slot="button-3" @click.native="$router.push({ name: 'scheduleReturn', params: { stage: 'ScheduleList' } })"  v-if="stage !== 'setFlowData' && generalSetting.mode === 'aeth'")
    action-button(title="手動退藥" slot="button-3" @click.native="setDrugSetMethod('manual')" v-if="stage !== 'setFlowData'"  )
    action-button(title="掃描條碼" slot="button-3" @click.native="setDrugSetMethod('barcode')"  v-if="stage !== 'setFlowData' && generalSetting.mode !== 'aeth'")
    action-button(title="取藥紀錄" slot="button-4" @click.native="setDrugSetMethod('event')" v-if="stage !== 'setFlowData'")
    action-button(title="開始退藥" slot="button-9" @click.native="startFlow" v-if="stage !== 'setFlowData'" :clickable="$store.state.drugInDevice.selectedDrugInDeviceID.length > 0 || $store.state.event.selectedEventId.length > 0")

</template>

<script>
import axios from 'axios';
import progressBar from './flowComp/ProgressBar';
import scanBarcode from './flowComp/ScanBarcode';
import eventTable from './flowComp/EventTable';
import drugList from './flowComp/DrugInDeviceList';
import MultiFlow from './ReturnDrugFlow/MultiFlow';
import Loader from './common/Loader';
import BottomButtons from './common/BottomButtons';
import AppBase from './ComponentBase/AppBase';


export default {
  name: 'ReturnDrug',
  extends: AppBase,
  data() {
    return {
      startType: 'event',
      eventType: 'FETCH',
      drugSetMethod: 'barcode',
      barcodeData: {},
      returnScheduleId: null,
    };
  },
  components: {
    progressBar,
    scanBarcode,
    eventTable,
    MultiFlow,
    Loader,
    drugList,
    BottomButtons,
  },
  created() {
    if (this.$route.params.drugSetMethod) {
      this.drugSetMethod = this.$route.params.drugSetMethod;
    }
    this.stage = 'selectDrug';
    this.progress = this.setupProgress();
    this.multiProgress = this.setupMultiProgress();
    this.confirmProgress = this.setupConfirmProgress();
    this.actionProgress = this.setupActionWrapProgress();
  },
  mounted() {
    this.$store.commit('SET_APP', '一般退藥');
    this.$store.commit('SET_PROGRESS', this.progress);
    this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
  },
  computed: {
    generalSetting() {
      return this.$store.state.generalSetting;
    },
  },
  methods: {
    setupProgress() {
      const prog = [];
      if (this.drugSetMethod === 'event') prog.push({ en: 'selectDrug', zh: '選擇事件' });
      if (this.drugSetMethod === 'manual') prog.push({ en: 'selectDrug', zh: '選擇位置' });
      if (this.drugSetMethod === 'barcode') prog.push({ en: 'selectDrug', zh: '掃描條碼' });
      prog.push({ en: 'selectReason', zh: '退藥理由' });
      prog.push({ en: 'medIdInput', zh: '輸入病歷號' });
      prog.push({ en: 'setPatchNo', zh: '確認批號' });
      prog.push({ en: 'setExpiredDate', zh: '確認效期' });
      prog.push({ en: 'setStorage', zh: '退藥數量' });
      if (this.$store.state.user.user.task_privilege.return_drug === false) {
        prog.push({ en: 'rxCheck', zh: '覆核動作' });
      }
      if (this.generalSetting.check_amount_first) {
        prog.push({ en: 'confirmAmount', zh: '確認數量' });
      }
      prog.push({ en: 'action', zh: '進行退藥' });
      return prog;
    },
    setupMultiProgress() {
      return [
        'confirm',
        'returnEmpty',
        'finish',
      ];
    },
    setupConfirmProgress() {
      const prog = [];
      prog.push('selectReason');
      prog.push('medIdInput');
      prog.push('setPatchNo');
      prog.push('setExpiredDate');
      prog.push('setStorage');
      if (this.$store.state.user.user.task_privilege.return_drug === false) {
        prog.push('rxCheck');
      }
      prog.push('action');
      return prog;
    },
    setupActionWrapProgress() {
      const prog = [];
      if (this.generalSetting.check_amount_first) {
        prog.push('confirmAmount');
      }
      prog.push('action');
      prog.push('next');
      return prog;
    },
    setDrugSetMethod(val) {
      this.$store.dispatch('unSelectAllDrugStorageAndDevices');
      this.$store.dispatch('unSelectAllEvent');
      this.drugSetMethod = val;
      if (val === 'manual') {
        this.startType = 'drugStorage';
      }
      if (val === 'barcode') {
        this.startType = 'event';
      }
      if (val === 'event') {
        this.startType = 'event';
      }
      this.progress = this.setupProgress();
      this.$store.commit('SET_PROGRESS', this.progress);
    },
    cancel() {
      this.$router.push({ name: 'Main' });
      this.$store.dispatch('recordAction', { eventType: 'CANCEL_RETURN' });
    },
    startFlow() {
      this.stage = 'setFlowData';
    },
    getAllConfirmData() {
      this.$store.dispatch('resetAll');
      this.$store.dispatch('getDrugInDevices');
      this.setDrugSetMethod('manual');
      this.stage = 'selectDrug';
      this.$store.commit('SET_CURRENT_STEP', 'selectDrug');
      this.barcodeData = {};
    },
    returnByPackBarcode(data) {
      // 長庚: 料位號 (3碼) + 數量(3碼) + 病歷號(7碼)
      const barcodeString = data.toString();
      //20190424 modified
      var code;
      var amount;
      var medRecordId;
      console.log('barcodeLen:',barcodeString.length);
      if(barcodeString.length>=20 && barcodeString.length<=22)
      {
        console.log('new barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, 18);
        medRecordId=medRecordId.split(' ').join('');//filter space char  
        console.log('料位號:',code);
        console.log('數量:',amount);
        console.log('病歷號:',medRecordId );
      }
      else
      {
        console.log('old barcode type');
        code = barcodeString.slice(0, 3);
        amount = parseInt(barcodeString.slice(3, 6), 10);
        medRecordId = barcodeString.slice(6, barcodeString.length).split('\r')[0];
        //20190510 新增化療藥局的病歷號會帶空白
        medRecordId=medRecordId.split(' ').join('');//filter space char
        console.log('料位號:',code);
        console.log('數量:',amount);
        console.log('病歷號:',medRecordId );
      }

      this.instance.get('/api/medication/', {
        params: {
          CGMH_number: code,
        },
      })
      .then((res) => {
        this.instance.get('/api/event/', {
          params: {
            event: 'FETCH',
            med_record_no: medRecordId,
            number1: -(amount),
            medication: res.data.results[0].id,
            drug_storage__isnull: false,
          },
        })
        .then((res) => {
          if (res.data.results.length === 0) {
            this.$store.commit('SET_MESSAGE', { type: 'warn', context: '查無紀錄' });
          } else {
            this.$store.dispatch('selectEvent', { eventId: res.data.results[0].id })
            .then(() => {
              this.barcodeData.medRecordId = medRecordId;
              this.barcodeData.amount = amount;
              console.log('success');
              this.stage = 'setFlowData';
            });
          }
        });
      });
    },
    async returnBySchedule(data) {
      this.returnScheduleId = parseInt(data.split(':')[1].split('***')[0], 10);
      this.drugSetMethod = 'returnSchedule';
      await this.$store.dispatch('setCurrentScheduleById', this.returnScheduleId);
    },
    getBarcode(scaned) {
      const data = scaned.toString();
      if (data.split(':')[0] === '***THC-schedule') {
        this.returnBySchedule(data);
      } else {
        this.returnByPackBarcode(data);
      }
    },
  },
  watch: {
    stage(val) {
      if (val === 'selectDrug') {
        this.$store.commit('SHOW_LOGOUT', true);
      } else {
        this.$store.commit('SHOW_LOGOUT', false);
      }
    },
  },
};
</script>

<style lang="sass">
.druglist-wrap
  height: 460px
  padding: 0 10px

</style>



// WEBPACK FOOTER //
// ReturnDrug.vue?105d3cf8